import React, { Component } from "react";
import Head from 'next/head';
import dynamic from 'next/dynamic'
import SlackWebHook from "../services/slack";
const CustomImage = dynamic(() => import('../components/CustomImage'));
const AKFooter = dynamic(() => import('../components/AKFooter'));

class AKLayout extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        setTimeout(() => {
            this.queryAppend();
        }, 100);

        window.onpopstate = function (e) {
            document.querySelector('body').classList?.remove("modal-open");
            document.querySelector('.modal-backdrop')?.classList.remove("modal-backdrop");
            document.querySelector('body').style = '';
        };
        try {
            if(process.env.NEXT_PUBLIC_ENV === 'production'){
                document.getElementById('pageurl').value = window.location.href;
            }
        } catch (e) {
            console.log(e);
        }
    }

    componentDidCatch(error, info) {
        try {
            SlackWebHook.sendSlackMessage(
                `Layout-${error.message}-${JSON.stringify(info)}-${JSON.stringify(
                    location
                )}`,
                process.env.NEXT_PUBLIC_SLACK_USERNAME,
                ":scream:",
                process.env.NEXT_PUBLIC_SLACK_ERROR_CHANNEL
            );
        } catch (e) {
            console.log(e);
        }
    }

    queryAppend = () => {
        if (sessionStorage.getItem("gclid") || sessionStorage.getItem("fbclid")) {
            let query = location.search.replace("?", "").replace("&", "=").split("=");
            if (!query.includes("gclid") && !query.includes("fbclid")) {
                let search = location.search === "" ? "?" : "";
                if (sessionStorage.getItem("gclid"))
                    search +=
                        search === "?"
                            ? sessionStorage.getItem("gclid") &&
                            "gclid=" + sessionStorage.getItem("gclid")
                            : sessionStorage.getItem("gclid") &&
                            "&gclid=" + sessionStorage.getItem("gclid");
                if (sessionStorage.getItem("fbclid"))
                    search +=
                        search === "?"
                            ? sessionStorage.getItem("fbclid") &&
                            "fbclid=" + sessionStorage.getItem("fbclid")
                            : sessionStorage.getItem("fbclid") &&
                            "&fbclid=" + sessionStorage.getItem("fbclid");
                const href = `${location.href}${search}`;
                if (sessionStorage.getItem("path") !== location.pathname) {
                    window.history.pushState(null, "", href);
                    sessionStorage.setItem("path", location.pathname);
                }
            }
        } else {
            let search = location.search
                .replace("?", "")
                .replace("&", "=")
                .split("=");
            if (search.length > 0) {
                if (search.includes("gclid")) {
                    const gci = search.findIndex((el) => el === "gclid");
                    sessionStorage.setItem("gclid", search[gci + 1]);
                }
                if (search.includes("fbclid")) {
                    const fbi = search.findIndex((el) => el === "fbclid");
                    sessionStorage.setItem("fbclid", search[fbi + 1]);
                }
            }
        }
    };

    render() {
        return (
            <div className="layout">
                <Head>
                    <title>Collegify | {this.props.page || 'Adarsh Khandelwal'}</title>
                    <meta name="google-site-verification" content="3hR3uCt9k8IJoHUHtc5aMy_nfLFRhwIZ5VyqjPRdrCw" />

                    {
                        process.env.NEXT_PUBLIC_ENV === 'production' &&
                        <>
                            <script src="https://www.googletagmanager.com/gtag/js?id=AW-975912079"/>
                            <script src="/js/AKgads.js" />
                        </>
                    }
                </Head>

                <header className="top-header ak-nav-bar">
                    <div className="container d-flex justify-content-center justify-content-md-between align-items-center h-100">
                        <div className="flex-row align-items-center">
                            <div className="logo-wrapper">
                                <CustomImage srcSetPaths={[{path: '/brand/logo.png?tr=w-130,f-avif', type: 'image/avif'},{path: '/brand/logo.png?tr=w-130,f-auto', type: 'image/webp'}]}
                                    mainSrc="/brand/logo.png?tr=w-130,f-png" alt="Collegify Logo" width="130" height="auto" imgCDN loading="eager" />
                            </div>
                            <div className="nav-topics"></div>
                        </div>
                        <div className='d-none d-md-block'>
                            <div className="d-flex justify-content-start align-items-center mb-1">
                                <CustomImage srcSetPaths={[{path: '/admission/mail-icon.png?tr=w-20,f-avif', type: 'image/avif'},{path: '/admission/mail-icon.png?tr=w-20,f-auto', type: 'image/webp'}]}
                                    mainSrc="/admission/mail-icon.png?tr=w-20,f-png" alt="Mail Icon" className="me-2"
                                    width="20px" height="auto" imgCDN loading="eager" />
                                <a href={`mailto:${this.props.email || 'richa@collegify.com'}`} className="mb-0">{this.props.email || 'richa@collegify.com'}</a>
                            </div>
                            <div className="d-flex justify-content-start align-items-center mb-0">
                                <CustomImage srcSetPaths={[{path: '/admission/phone-icon.png?tr=w-20,f-avif', type: 'image/avif'},{path: '/admission/phone-icon.png?tr=w-20,f-auto', type: 'image/webp'}]}
                                    mainSrc="/admission/phone-icon.png?tr=w-20,f-png" alt="phone icon" className="me-2"
                                    width="20px" height="auto" imgCDN loading="eager" />
                                <a href={`tel:+91${this.props.mobile || '8505831919'}`} className="mb-0">+91 {this.props.mobile || '85058 31919'}</a>
                            </div>
                        </div>
                    </div>
                </header>
                <main>
                    { this.props.children }
                </main>
                <AKFooter />
            </div>
        );
    };
}
export default AKLayout;
